import  bill_1 from './bill_1.png';
import  bill_2 from './bill_2.png';
import  bill_3 from './bill_3.png';
import  invoice_detail1 from './invoice_detail1.png';
import  invoice_detail2 from './invoice_detail2.png';
import  invoice_detail3 from './invoice_detail3.png';
import  invoice_detail4 from './invoice_detail4.png';
import  banner_show_v1 from './banner_show_v1.jpg';
import  banner_show_v2 from './banner_show_v2.jpg';
import  banner_show_v3 from './banner_show_v3.jpg';


export const  images ={
bill_1,
bill_2,
bill_3, 
invoice_detail1, invoice_detail2, invoice_detail3, invoice_detail4, 
banner_show_v1, banner_show_v2, banner_show_v3
}